import { cn } from "@/shared/lib/cn";

interface LogoMarkProps {
  /** Rendered size in px (square). 20 is the smallest legible size. */
  size?: 20 | 24 | 28 | 32 | 40 | 56;
  /** Name it when the mark stands alone; leave it decorative beside the wordmark. */
  title?: string;
  className?: string;
}

/**
 * The 404 mark: a cream bracket with its corner popped out as a sage bar, on the charcoal plate.
 * Drawn from the same paths as the favicon so it stays crisp at every size.
 */
export function LogoMark({ size = 28, title, className }: LogoMarkProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={cn("shrink-0", className)}
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <rect width="64" height="64" rx="14" className="fill-mark" />
      <path d="M10 15h24v7H17v25h29v7H10z" className="fill-mark-ink" />
      <path d="M39 9h8v18h-8z" className="fill-mark-accent" />
    </svg>
  );
}
